<ng-container *ngIf="inlineEditor else popupEditor">
    <se-date-cell-editor-inline tabindex="0"
                                [value]="value"
                                [inputType]="inputType"
                                [timeInputFormat]="timeInputFormat"
                                [startEdited]="cellStartEdited"
                                [required]="required"
                                [width]="cellWidth"
                                (spaceBarClick)="_onSpaceBarClick($event)"
                                (formReady)="_onFormReady($event)"
                                (escPressed)="_onEscPressed($event)"
                                (enterPressed)="_onEnterPressed($event)"
                                (tabToTheNext)="_tabToTheNextCell()">
    </se-date-cell-editor-inline>
</ng-container>

<ng-template #popupEditor>
    <se-date-cell-editor-popup tabindex="0"
                               [value]="value"
                               [inputType]="inputType"
                               [timeInputFormat]="timeInputFormat"
                               [required]="required"
                               [width]="cellWidth"
                               (spaceBarClick)="_onSpaceBarClick($event)"
                               (formReady)="_onFormReady($event)"
                               (escPressed)="_onEscPressed($event)"
                               (enterPressed)="_onEnterPressed($event)"
                               (tabToTheNext)="_tabToTheNextCell()">
    </se-date-cell-editor-popup>
</ng-template>


